import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexContainer } from '@bos/ui';
import { useMobilityUiConfig } from '../context/MobilityUiProvider/MobilityUiProvider';
import { InfoTooltip } from './InfoTooltip';
export const SectionHeader = ({ title, variant = 'h3', tooltipText, }) => {
    const { Text } = useMobilityUiConfig();
    return (_jsxs(FlexContainer, { direction: 'row', gap: true, children: [_jsx(Text, { variant: variant, children: title }), tooltipText && _jsx(InfoTooltip, { text: tooltipText })] }));
};
